import React from 'react';

import { UiSignupLayout } from '../../common/UiSignup';
import useIsDirectBuy from '../../util/hooks/DirectBuy';
import DirectBuyContainer from './subcomponents/DirectBuyContainer';
import LeftContainer from './subcomponents/LeftContainer';
import RightContainer from './subcomponents/RightContainer';

const SignupPageComponent = () => {
    const isDirectBuyFlow = useIsDirectBuy();

    return <UiSignupLayout
        left={<LeftContainer />}
        right={isDirectBuyFlow ? <DirectBuyContainer /> : <RightContainer />}
        showLeftContainer={!isDirectBuyFlow} />;
};

export default SignupPageComponent;
